"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
const tslib_1 = require("tslib");
const lift_brand_token_hook_1 = require("@lift/design-system-react-web/dist/contexts/lift-brand-token.hook");
const react_1 = tslib_1.__importStar(require("react"));
const styled_components_1 = require("styled-components");
const global_styles_1 = require("../../styles/global-styles");
const themes_1 = require("../../themes");
const theme_manager_1 = require("../theme-manager");
const theme_context_1 = require("./theme.context");
const ThemeProvider = ({ children }) => {
    const [theme, setCurrentTheme] = (0, react_1.useState)(themes_1.themeWhitelabel);
    const temaLift = (0, lift_brand_token_hook_1.useBrandToken)();
    const { altoContraste, toggleAltoContraste } = (0, theme_manager_1.useThemeManager)();
    const setTheme = (0, react_1.useCallback)((value) => {
        switch (value) {
            case 'estacio-high-contrast':
                return setCurrentTheme((0, themes_1.themeEstacioHighContrast)(temaLift));
            case 'ibmec-high-contrast':
                return setCurrentTheme((0, themes_1.themeIbmecHighContrast)(temaLift));
            case 'wyden-high-contrast':
                return setCurrentTheme((0, themes_1.themeWydenHighContrast)(temaLift));
            case 'idomed-high-contrast':
                return setCurrentTheme((0, themes_1.themeIdomedHighContrast)(temaLift));
            case 'withelabel':
            default:
                return setCurrentTheme((0, themes_1.themeWhitelabel)());
        }
    }, [temaLift]);
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(theme_context_1.ThemeContext.Provider, { value: { theme, setTheme, altoContraste, toggleAltoContraste } }, children),
        react_1.default.createElement(global_styles_1.GlobalStyle, null)));
};
exports.ThemeProvider = ThemeProvider;
